import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import BookingErrorConfirmation from "../Components/BookingErrorConfirmation";

const SessionContextBookingErrorConfirmation = SessionContextValueProvider({
  Component: BookingErrorConfirmation,
  map: ({ customer: { firstName, lastName } }) => ({ customerName: `${firstName} ${lastName}` })
});

export default SessionContextBookingErrorConfirmation;
